<template>
  <div class="dialog">
    <div class="dialog_box">
      <img class="close_btn pointer" @click="$store.commit('hideDialog')" src="@/assets/close-icon.png" />
      <span class="dialog_box_title">发表</span>
      <textarea class="dialog_box_textarea" v-model="comment"></textarea>
      <p class="dialog_box_warning"><img src="@/assets/warning-icon.png" /><span>提示：提交后管理员审核并回复，回复内容可在“联系我们”页面查看。</span></p>
      <span class="dialog_box_btn pointer" @click="onSubmit">
        <img src="@/assets/publish-icon.png" />
        <span>发表</span>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'dialog',
  components: {},
  data () {
    return {
      comment: ''
    }
  },
  created () {
  },
  mounted () {
  },
  computed: {},
  methods: {
    onSubmit () {
      if (this.comment) {
        this.$axios.commentSave({comment: this.comment}).then(res => {
          if (res) {
            this.$message.success('操作成功!')
            this.$store.commit('hideDialog')
          }
        })
      } else {
        this.$message.warning('请输入发表内容!')
      }
    }
  },
  watch: {}
}
</script>

<style scoped>
  .dialog { position: fixed; top: 0; left: 0; width: 100%; height: 100%; background-color: rgba(0, 0, 0, 0.5); z-index: 10; }
  .dialog .dialog_box { width: 800px; height: 500px; background: #FFFFFF; border-radius: 3px; position: absolute; top: 200px; left: 50%; margin-left: -400px; padding: 30px; }
  .dialog .dialog_box .close_btn { position: absolute; height: 40px; width: 40px; right: 0; top: 0; }
  .dialog .dialog_box .dialog_box_title { display: block; font-size: 20px; font-weight: 600; color: #ABCB88; line-height: 20px; margin-bottom: 20px; }
  .dialog .dialog_box .dialog_box_textarea { width: 740px; height: 260px; border-radius:6px; border: 1px solid #DCDFE6; outline: none; padding: 15px; resize: none; margin-bottom: 20px; }
  .dialog .dialog_box .dialog_box_warning { margin-bottom: 20px; }
  .dialog .dialog_box .dialog_box_warning img { width: 20px; height: 20px; margin-right: 5px; }
  .dialog .dialog_box .dialog_box_warning span { font-size: 14px; color: #FF9B59; line-height: 14px; }
  .dialog .dialog_box .dialog_box_btn { display: block; width: 160px; height: 62px; background: #76BF28; border-radius: 6px; text-align: center; line-height: 62px; float: right; }
  .dialog .dialog_box .dialog_box_btn img { width: 18px; height: 18px; margin-right: 5px; }
  .dialog .dialog_box .dialog_box_btn span { font-size: 16px; color: #FFFFFF; line-height: 16px; }
  .dialog .dialog_box .dialog_box_btn:hover { background-color: #65A422; }
</style>



// WEBPACK FOOTER //
// src/components/contact/dialog.vue